import React from 'react';
import LoaderSpinner from './LoaderSpinner';

/**
 * Button with centralized loading state (spinner + label).
 */
export default function LoadingButton({
  loading = false,
  loadingLabel = 'Saving...',
  children,
  className = '',
  style,
  disabled,
  ...rest
}) {
  return (
    <button
      type="button"
      className={className}
      style={style}
      disabled={loading || disabled}
      {...rest}
    >
      {loading ? (
        <span className="shm-btn-loading">
          <LoaderSpinner size={17} />
          <span>{loadingLabel}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
